import {Card, Typography, useMediaQuery} from "@mui/material";
import SuggestedItem from "./SuggestedItem";
import {useTranslation} from "react-i18next";
import {Recommendation} from "../../pages/Results";
import {theme} from "../../theme.ts";

export default function SuggestionGroup(props: { title: string; items: Recommendation[] }) {
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div style={{ marginTop: "20px" }}>
            <Typography
                variant="h5"
                sx={{ marginBottom: "0.5rem", paddingX: 2 }} // Padding für die Überschrift
            >
                {t(`product_type_${props.title}`)}
            </Typography>
            <Card
                elevation={0}
                sx={{ borderRadius: 0, width: "100%" }}>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: isMobile ? "column" : "row",
                    padding: "10px",
                }}>
                    {props.items.map((item, index) => (
                        <div key={item.article_informaton_i18n[0].article_id} style={{ width: isMobile ? "100%" :"33%" }}>
                            <SuggestedItem item={item} index={index} />
                        </div>
                    ))}
                </div>
            </Card>
        </div>
    );
}
